import { CheckIcon, Combobox, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { EventType } from '../../../../../../types';

const TRANS_PATH = 'TOURING_SCHEDULE';

type ScheduleFilterComboboxOptionPropsType = {
  value: EventType;
  isActive: boolean;
};

export const ScheduleFilterComboboxOption: React.FC<
  ScheduleFilterComboboxOptionPropsType
> = ({ value, isActive }) => {
  const { t } = useTranslation('dashboard');

  return (
    <Combobox.Option value={value} active={isActive}>
      <Group gap="sm">
        {isActive ? <CheckIcon size={12} /> : null}
        <span>{t(`${TRANS_PATH}.FILTER_${value}`)}</span>
      </Group>
    </Combobox.Option>
  );
};
